import { render } from "./SimplePage.vue?vue&type=template&id=6f78e823"
import script from "./SimplePage.vue?vue&type=script&lang=js"
export * from "./SimplePage.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/ktl/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__